<template lang="html">
<div class="single-chart-modal-wrap">

    <v-dialog v-model="enabled" max-width="750">
        <v-card class="single-chart-modal">
            <v-card-title v-text="title" class="headline"></v-card-title>
            <v-card-text>
                <single-chart :chartData="chartDatasets" v-if="chartDatasets" />
                <div class="loading" v-if="!chartDatasets">
                    <p>Loading chart data...</p>
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" @click.native="close()" flat="flat">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</div>
</template>

<script>
import gql from 'graphql-tag';
import * as appColors from '@/functions/appColors';
import SingleChart from '@/components/SingleChart';


export default {
    components: {
        SingleChart,
    },
    data() {
        return {
            chart: null,
            id: 'single-chart-modal-canvas',
            chartDatasets: null,
            defaultDataset: {
                borderColor: String(appColors.sparklineColor1),
                borderWidth: 2,
                pointRadius: 1,
                fill: false,
                cubicInterpolationMode: 'monotone',
            },
            defaultOptions: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                        },
                        gridLines: {
                            color: String(appColors.axisBorder),
                        },
                    }],
                    xAxes: [{
                        type: 'time',
                        distribution: 'linear',
                        time: {
                            tooltipFormat: 'MMM DD, YYYY',
                            unit: 'month',
                        },
                    }],
                },
            },

        };
    },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        chartDetails: {
            type: Object,
            required: false,
        },
    },
    computed: {
        enabled: {
            get() {
                return this.show;
            },
            set(val) {
                this.close(val);
            },
        },
        title() {
            const { title, units } = this.chartDetails;
            return `${title} (${units})`;
        },
        chartKey() {
            const { paramId, units } = this.chartDetails;
            return `${paramId}__${units}`;
        },
    },
    apollo: {
        chartData: {
            query: gql`query stationChemChart($id: Int!, $paramId: Int!, $unit: String!) {
                getStation(id: $id) {
                    chemistry {
                        single_chart(paramId: $paramId, unit: $unit),
                    }
                }
            }`,
            variables() {
                return {
                    id: this.chartDetails.stationId,
                    paramId: this.chartDetails.paramId,
                    unit: this.chartDetails.units,
                };
            },
            update(data) {
                const chart = data.getStation.chemistry.single_chart;
                const formatted = chart.map((e) => {
                    const d = e.dt;
                    const v = Number(e.v);
                    return {
                        v,
                        d,
                    };
                });
                return formatted;
            },
            result() {
                this.renderChart();
            },
        },
    },
    methods: {
        close(val) {
            this.$emit('close', val);
        },
        /**
         * initial chart configuration
         * (@TEMP: format for chart.js until the single-chart component switches to D3)
         */
        renderChart() {
            if (this.chart !== null) {
                return;
            }
            this.chart = {};

            // create datasets
            const datasets = [{}].map((d) => {
                const merged = Object.assign({}, this.defaultDataset, d);
                return merged;
            });
            const labels = this.chartData.map(e => e.d);

            // merge with default options
            const options = Object.assign({}, this.defaultOptions);

            // set y-axis label
            const units = this.chartDetails.units;
            if (units) {
                options.scales.yAxes[0].scaleLabel = {
                    display: true,
                    labelString: units,
                };
            }

            datasets[0].data = this.chartData.map(e => e.v);
            datasets[0].label = this.chartDetails.title;

            this.chartDatasets = {
                type: 'line',
                data: {
                    labels,
                    datasets,
                },
                options,
            };
        },
    },
};
</script>

<style scoped lang="scss">
.single-chart-modal {
    .loading {
        height: 16rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/SingleChartModal.vue